/**
 *
 * ModalActionPlanCreate
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import axios from "axios"
import questionIcon from "images/question.svg"
import alertSvg from "images/alert.svg"
import {
  Modal,
  Button,
  Input,
  TreeSelect,
  Spin,
  Tooltip,
  Popover,
  Empty,
  Select as AntdSelect,
  Divider,
  Space,
  Row,
  Col,
} from "antd"
import { Icon } from "@ant-design/compatible"
import imgCreateActionPlan from "../../images/freemium/create-action-plan.svg"
import {
  getUtilsActionPlanApi,
  saveActionPlanApi,
  getMeasuresActionPlan,
  getActionPlansWithIa,
} from "services/actionPlans"
import { requestUpgradeApi } from "services/requestUpgrade"
import { addLevel, generateTree } from "utils/utils"
import { flatMap, isEqual, orderBy } from "lodash"
import Fade from "react-reveal/Fade"
import ActionPlanTaskResumen from "../ActionPlanTaskResumen"
import moment from "moment"
import checkIcon from "images/check.svg"
import emptyStateRecommendations from "images/empty-state-recommendations.svg"
import { Form } from "@ant-design/compatible"
import Select from "components/Select"
import ModalCustom from "components/ModalCustom"
import ActionPlanTaskForm from "components/ActionPlanTaskForm"
import TruncateText from "components/TruncateText"
import ButtonsFooter from "components/ButtonsFooter"
import ModalDeleteSimple from "components/ModalDeleteSimple"
import "@ant-design/compatible/assets/index.css"
import "./index.less"
import {
  MinusCircleTwoTone,
  PlusCircleTwoTone,
  MinusCircleFilled,
  AntDesignOutlined,
  LinkOutlined,
  LoadingOutlined,
  CloseCircleOutlined,
  EditFilled,
  DeleteOutlined,
} from "@ant-design/icons"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import ResultByDimensionV2 from "../ResultByDimension/index2"
import ResultByDimensionActionPlan from "../ResultByDimensionActionPlan"
import PreviewPDAWithIA from "../PreviewPDAWithIA"
import { loadTexts, sanitize, getLanguage } from "../../utils/i18n"
import { uuid } from "../../utils/functions"
import iconX from "images/x-icon.svg"
import IconoVaritaMagica from "./IconoVaritaMagica"
import IconoRegenerate from "./IconoRegenerate"
import beta from "images/beta.svg"
import globo from "images/globo.svg"

import {
  LOCAL_USER_EMAIL,
  LOCAL_COMPANY_NAME,
  LOCAL_ACTIVE_ROL_NAME,
  LOCAL_COMPANY_HUBSPOT,
  LOCAL_PDA_IA_ENABLED,
  LOCAL_AI_LIMIT_REACHED,
} from "../../utils/storage"
import EditEvidenceForm from "../EditEvidenceForm"
import { modalGlobalConfig } from "antd/lib/modal/confirm"
import Onboarding from "../Onboarding"
const { TreeNode } = TreeSelect
const FormItem = Form.Item

const recursiveFindChildsId = (array = [], data) => {
  array.push(data.id_dimension)
  if (data.childs && data.childs.length > 0) {
    data.childs.map((e) => recursiveFindChildsId(array, e))
  }
  return array
}

/* eslint-disable react/prefer-stateless-function */
class ModalActionPlanCreate extends React.Component {
  intl = loadTexts("dashboard")
  is_new = true
  abortController = null

  createAbortSignal = () => {
    this.cancelPendingRequests()
    this.abortController = new AbortController()
    return this.abortController.signal
  }

  cancelPendingRequests = () => {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = null
    }
  }

  id_profile_ambassador =
    this.props.initialData && this.props.initialData.selectedAmbassador
      ? this.props.initialData.selectedAmbassador.id_ambassador
      : null

  unassignedAmbassador = false
  state = {
    loadingEditable: false,
    modal: false,
    modalDimensions: false,
    modalPreview: false,
    view: false,
    employees: [],
    meditions: [],
    divisions: [],
    dimensions: [],
    ambassadors: [],
    selectedDivision: null,
    selectedDimension: [],
    selectedMedition: null,
    selectedAmbassador: null,
    loadingDimensions: false,
    loadingMeditions: true,
    loadingDivisions: false,
    openDimensions: [],
    name: "",
    description: "",
    linkTitle: "",
    linkDescription: "",
    addingEvidence: false,
    evidences: [],
    loadingSave: false,
    secondStep: false,
    taskCreate: false,
    tasks: [],
    actionPlanEditInfo: {},
    currentTask: {},
    currentTaskIndex: null,
    modalDeleteTaks: false,
    modalReplaceRecommendation: false,
    loadingRecommendations: false,
    recommendations: [],
    dimensionsToRecommendations: [],
    recommendation_selected: {},
    temporalRecommendation: {},
    modalClose: false,
    loadingResults: false,
    viewModalAction: false,
    selectRowsDimensions: [],
    disabledSubmit: false,
    newTasks: [],
    selectedMeditionObject: {},
    loadingButton: false,
    selectedRows: [],
    pdaData: [],
    pdaDataStorage: [],
    indexPdaData: 0,
    loadingPdaIA: false,
    clickRegenerate: 1,
    disableButtonRegenerate: false,
    disableButtonGenerate: true,
    loadingButton: false,
    selectedMeditionObject: {},
    dashboard_enter: false,
    loadingButtonIa: false,
    loadingButtonNormal: false,
    loadingDimensionsWithIa: false,
    selectedDivisionMemory: null,
    selectedDimensionMemory: null,
    selectedMeditionMemory: null,
    pdaFail: false,
    modalDeleteEvidence: false,
    evidenceToDeleteId: null,
    evidencesDelete:[]
  }

  componentDidUpdate() {
    if (this.state.view) {
      document.querySelector("body").classList.add("openViewCreatePlanAction")
    } else {
      document
        .querySelector("body")
        .classList.remove("openViewCreatePlanAction")
    }
  }

  componentDidMount() {
    const { visible } = this.props
    document.addEventListener("mousedown", this.handleClickOutside)
    if (visible) {
      this.setState({ modal: true })
    }
    this.loadMeasureData({ initial: true })
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
    this.cancelPendingRequests()
  }

  UNSAFE_componentWillReceiveProps = async (props) => {
    if (
      this.props.dashboard_enter != props.dashboard_enter &&
      props.dashboard_enter
    ) {
      this.initialDataPreviewWithIA(props)
      props.setStateFrom("dashboard_enter", false)
    }

    if (this.props.visible != props.visible && props.visible) {
      const isEdit = !!props.modalActionPlanEditId
      this.is_new = !isEdit
      this.setState({ modal: true, view: isEdit, actionPlanEditInfo: {} })
      if (isEdit) {
        this.loadEditDetails(props.modalActionPlanEditId)
      }
      if (props.initialData) {
        if (props.visible) {
          if (!this.props.fromAnalysis)
            this.loadBasicData({
              initial: true,
              modalActionPlanCreateIa: props.modalActionPlanCreateIa,
            })
        }
        // Call when set data for default
        const validMeditionAndDivision =
          props.initialData.measure && props.initialData.division
        this.setState(
          {
            modal: !validMeditionAndDivision,
            modalDimensions: validMeditionAndDivision,
            loadingDimensions: validMeditionAndDivision,
            loadingDivisions: true,
            selectedDivision: props.initialData.division || null,
            selectedMedition: props.initialData.measure || null,
            selectedAmbassador: props.initialData.selectedAmbassador || null,
            selectedDimension: props.initialData.dimensions || [],
          },
          async () => {
            if (validMeditionAndDivision) {
              await this.loadDimensions(true)
            } else {
              await this.loadBasicData({
                division:
                  this.state.selectedDivision &&
                  this.state.selectedDivision.id_division,
                medition: this.state.selectedMedition,
              })
            }
          }
        )
      } else {
        await this.loadBasicData({
          initial: true,
          modalActionPlanCreateIa: props.modalActionPlanCreateIa,
        })
      }
    }
  }

  setStateFrom = (key, value) => {
    this.setState({ [key]: value })
  }
  addEvidence = async () => {
    const { linkTitle, linkDescription, evidences } = this.state
    console.log(linkTitle, linkDescription)
    if (!linkTitle || !linkDescription) return
    if(!navigator.onLine){
      this.setState({ addingEvidence: false })
      message.error(this.intl.modalActionPlanCreate.createModal.evidence.addEvidenceError)
      return;
    }
      this.setState({ addingEvidence: true })

      const newEvidence = {
        id: uuid(),
        title: linkTitle.trim(),
        url: linkDescription.trim(),
        date: moment(),
        isEditing: false,
      }

      this.setState({
        evidences: [newEvidence, ...evidences],
        linkTitle: "",
        linkDescription: "",
        addingEvidence: false,
      })
      message.success(this.intl.modalActionPlanCreate.createModal.evidence.addEvidenceSuccess)

    
  }
  loadEditDetails = async (id) => {
    this.setState({ loadingEditable: true })
    try {
      const result = await fetchGlobalApi({
        method: "GET",
        endpoint: `action-plans/${id}/edit/`,
      })
      const { data } = result
      data.action_plan.tasks = data.action_plan.tasks.map((e) => {
        e.date_start = e.date_start
          ? moment(e.date_start, "DD-MM-YYYY").format("YYYY-MM-DD")
          : null
        e.date_end = moment(e.date_end, "DD-MM-YYYY").format("YYYY-MM-DD")
        e.id_employee =
          e.employees && e.employees.length > 0
            ? e.employees[0].id_employee
            : null
        return e
      })
      this.unassignedAmbassador = !(data.ambassadors.length > 0)
      this.setState(
        {
          selectedDivision: data.divisions[0],
          selectedDimension: flatMap(
            data.dimensions,
            (item) => item.id_dimension
          ),
          selectedMedition: data.measures[0].id_measure,
          selectedMeditionObject: data.measures[0],
          selectedAmbassador:
            data.ambassadors.length > 0 ? data.ambassadors[0] : null,
          name: data.action_plan.name,
          description: data.action_plan.description,
          evidences: Array.isArray(data.evidences)
            ? data.evidences.map((ev) => ({
                ...ev,
                ...(ev.id_evidence ? { id: ev.id_evidence } : {}),
              }))
            : [],
          actionPlanEditInfo: data.action_plan,
          tasks: data.action_plan.tasks,
        },
        async () => {
          await this.loadDimensions(false)
          this.setDimensionsToRecommendations()
        }
      )
    } catch (error) {}
  }

  /**
   * Carga lo necesario para iniciar a crear un plan de acción
   * Recibe un objeto, el cuál será usado para enviar según sea el selector: medición, división
   */
  loadBasicData = async (obj = {}) => {
    try {
      const result = await getUtilsActionPlanApi({
        searchByIdMeasure: obj.medition,
        searchByIdDivisionAmbassadors: obj.division,
        id_ambassador_profile_filter: this.id_profile_ambassador,
        actionPlanCreateIa:
          obj.initial || obj.modalActionPlanCreateIa
            ? obj.modalActionPlanCreateIa
            : this.props.modalActionPlanCreateIa,
        signal: obj.signal,
      })
      const { data } = result.data
      if (obj.initial) {
        // this.props.canCreate(data.result.measures.length > 0)
        this.props.setMeasures(data.result.measures)
      }
      this.setState(
        {
          employees: data.result.employees,
          meditions: data.result.measures,
          divisions: data.result.divisions,
          ambassadors: data.result.ambassadors,
          loadingMeditions: false,
          loadingDivisions: false,
          loadingAmbassadors: false,
        },
        () => {
          // Al ser asincrono los states, creamos una variable
          const { selectedDivision } = this.state
          let setCurrentAmbassador = false
          let setCurrentAmbassadorData = null

          if (data.result.ambassadors.length > 0 && selectedDivision) {
            let firstAmbassadors = data.result.ambassadors[0]
            let findByDivision = data.result.ambassadors.filter(
              (e) => e.id_division === selectedDivision.id_division
            )
            if (findByDivision.length > 0 && !this.unassignedAmbassador) {
              // Este bloque obtendrá el embajador según su ID de perfil.
              if (this.id_profile_ambassador) {
                findByDivision = findByDivision.filter(
                  (e) => e.id_ambassador === this.id_profile_ambassador
                )
              }

              // Bloque que ayuda a buscar si existe o no el embajador actual después del cambio
              // de división
              if (obj.currentAmbassador && !this.is_new) {
                setCurrentAmbassador = true
                const validateIfExistAmbassador = findByDivision.find(
                  (e) => e.id_ambassador === obj.currentAmbassador.id_ambassador
                )
                if (validateIfExistAmbassador) {
                  setCurrentAmbassadorData = obj.currentAmbassador
                } else {
                  setCurrentAmbassadorData = null
                }
              }

              const randomAmbassador =
                findByDivision[
                  Math.floor(Math.random() * findByDivision.length)
                ]
              this.setState(
                {
                  selectedAmbassador: setCurrentAmbassador
                    ? setCurrentAmbassadorData
                    : this.state.selectedAmbassador
                    ? this.state.selectedAmbassador
                    : randomAmbassador,
                },
                () => {
                  // Adicionar en la lista de employees al embajador actual predeterminado del pda.
                  const { selectedAmbassador } = this.state
                  if (
                    selectedAmbassador &&
                    data.result.employees.findIndex(
                      (fe) => fe.id_employee === selectedAmbassador.id_employee
                    ) < 0
                  ) {
                    selectedAmbassador.picture_profile =
                      selectedAmbassador.profile_picture
                    data.result.employees.unshift(selectedAmbassador)
                    this.setState({ employees: data.result.employees })
                  }
                }
              )
            }
          }
        }
      )
      if (
        (obj.initial
          ? obj.modalActionPlanCreateIa
          : this.props.modalActionPlanCreateIa) &&
        obj.initial
      ) {
        this.setState({
          selectedMedition:
            data.result.measures.length > 0
              ? data.result.measures[0].id_measure
              : null,
          loadingDivisions: true,
          selectedDivision: null,
          selectedMeditionObject:
            data.result.measures.length > 0 ? data.result.measures[0] : null,
        })

        this.loadBasicData({ medition: this.state.selectedMedition })
      }
    } catch (error) {}
  }
  loadMeasureData = async (obj = {}) => {
    try {
      const result = await getMeasuresActionPlan({
        searchByIdMeasure: obj.medition,
        searchByIdDivisionAmbassadors: obj.division,
        id_ambassador_profile_filter: this.id_profile_ambassador,
      })
      const { data } = result.data
      if (obj.initial) {
        this.props.canCreate(data.result.measures.length > 0)
        this.props.setMeasures(data.result.measures)
      }
    } catch (error) {}
  }

  nextLoadDimensions = async () => {
    const signal = this.createAbortSignal()

    this.setState({
      loadingDimensions: true,
    })

    try {
      woopraTrack("Seleccionar plan de acción")
      const division_info = this.state.selectedDivision
      const selected_measure_object = this.state.selectedMeditionObject
      const selected_segment = this.state.selectedSurvey
      const currentAmbassador = this.state.selectedAmbassador || null

      if (selected_measure_object.id_scope_type === 2) {
        const dimensions = await fetchGlobalApi({
          method: "GET",
          endpoint: `reports/measure/${this.state.selectedMedition}/divisions/${division_info.id_division}/dimensions?id_segment=${selected_segment}`,
          signal,
        })

        const { questions } = dimensions.data.metric_total
        questions.map((e) => {
          return (e.id = parseInt(
            e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
          ))
        })

        const dimensions_data = dimensions.data.data.filter(
          (d) => d.engagement === false
        )

        let result = generateTree("id", "id_parent", [
          ...JSON.parse(JSON.stringify(dimensions_data)),
          ...JSON.parse(
            JSON.stringify(questions.filter((d) => d.engagement === false))
          ),
        ])
        result.forEach(addLevel(1))
        result = orderBy(result, "percent", "asc")
        if (currentAmbassador && !this.is_new) {
          this.id_profile_ambassador = null
        }
        await this.loadBasicData({
          division: division_info.id_division,
          medition: this.state.selectedMedition,
          currentAmbassador,
          signal,
        })
        this.setState(
          {
            dimensions: result,
            loadingDimensions: false,
          },
          () => {
            setTimeout(() => {
              overflowTreeSelect(".dimension-action-plan-create-modal")
            }, 1000)
          }
        )
      }
    } catch (error) {
      if (axios.isCancel(error)) return
      this.setState({ loadingDimensions: false })
      console.log(error)
    }
  }

  initialDataPreviewWithIA(props) {
    this.setState({ dashboard_enter: props.dashboard_enter }, () => {
      if (this.state.dashboard_enter) {
        this.setState(
          {
            pdaDataStorage: JSON.parse(props.contentPdaIa.content_output) || [],
            indexPdaData: props.contentPdaIa.pdas_counter,
          },
          () => {
            this.setState(
              (prevState) => ({
                pdaData: [
                  {
                    ...prevState.pdaDataStorage[prevState.indexPdaData],
                    selected: true,
                  },
                ],
                modalPreview: true,
                selectedDivision: {
                  ...prevState.selectedDivision,
                  id_division: props.id_division,
                  division_name: props.division_name,
                },
                selectedMedition: props.id_measure,
                id_dimension: props.id_dimension,
                id_measure: props.id_measure,
                id_dimension_parent: props.id_dimension_parent,
                id_division: props.id_division,
                dimension_name: props.dimension_name,
                dimension_color: props.dimension_color,
                value_visible: props.dimension_value,
                id_company: props.id_company,
                selectedAmbassador: {
                  ...prevState.selectedAmbassador,
                  id_ambassador: props.id_ambassador,
                  id_employee: props.id_employee,
                },
                selectedDimension: [props.id_dimension] || [],
                dimensions: [props.dimensions],
                selectedSurvey: props.id_survey,
                selectedMeditionObject: {
                  ...prevState.selectedMeditionObject,
                  id_scope_type: props.id_scope_type,
                  name: props.measure_name,
                },
              }),
              () => {}
            )
          }
        )
      }
    })
  }

  loadDimensionsWithIA = async () => {
    try {
      const signal = this.createAbortSignal()

      this.setState({
        loadingDimensionsWithIa: true,
      })
      const division_info = this.state.selectedDivision
      const selected_measure_object = this.state.selectedMeditionObject
      const currentAmbassador = this.state.selectedAmbassador

      let dimensions = {}

      const surveys = await fetchGlobalApi({
        method: "GET",
        endpoint: `measure/${this.state.selectedMedition}/division/${division_info.id_division}/surveys`,
        signal,
      })
      const surveys_data = surveys.data.data

      if (selected_measure_object.id_scope_type === 2) {
        dimensions = await fetchGlobalApi({
          method: "GET",
          endpoint: `reports/measure/${this.state.selectedMedition}/divisions/${division_info.id_division}/dimensions?id_segment=${surveys_data[0].measure_id_segment}`,
          signal,
        })
        this.setState({ selectedSurvey: surveys_data[0].measure_id_segment })
      } else {
        dimensions = await fetchGlobalApi({
          method: "GET",
          endpoint: `reports/measure/${this.state.selectedMedition}/divisions/${division_info.id_division}/dimensions`,
          signal,
        })
      }
      const { questions } = dimensions.data.metric_total
      questions.map((e) => {
        return (e.id = parseInt(
          e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
        ))
      })

      const dimensions_data = dimensions.data.data.filter(
        (d) => d.engagement === false
      )

      let result = generateTree("id", "id_parent", [
        ...JSON.parse(JSON.stringify(dimensions_data)),
      ])
      result.forEach(addLevel(1))
      result = orderBy(result, "percent", "asc")
      if (currentAmbassador && !this.is_new) {
        this.id_profile_ambassador = null
      }
      await this.loadBasicData({
        division: division_info.id_division,
        medition: this.state.selectedMedition,
        currentAmbassador,
        modalActionPlanCreateIa: true,
        signal,
      })
      this.setState(
        {
          dimensions: result,
          loadingDimensionsWithIa: false,
          surveys: surveys_data,
          dashboard_enter: false,
        },
        () => {
          setTimeout(() => {
            overflowTreeSelect(".dimension-action-plan-create-modal")
          }, 1000)

          this.handleOk()
        }
      )
    } catch (error) {
      if (axios.isCancel(error)) return
      console.log(error)
      this.setState({ loadingDimensionsWithIa: false })
    }
  }

  loadDimensions = async (
    secondStep,
    currentAmbassador = null,
    viewModal = false
  ) => {
    const signal = this.createAbortSignal()

    this.setState({
      loadingDimensions: true,
      loadingAmbassadors: true,
      ambassadors: [],
      selectedSurvey: null,
      disableButtonGenerate: true,
      // selectedAmbassador: null,
    })
    this.setState({
      loadingResults: viewModal,
      viewModalAction: viewModal,
    })
    try {
      woopraTrack("Seleccionar plan de acción")
      const division_info = this.state.selectedDivision
      const selected_measure_object = this.state.selectedMeditionObject

      let dimensions = {}

      const surveys = await fetchGlobalApi({
        method: "GET",
        endpoint: `measure/${this.state.selectedMedition}/division/${division_info.id_division}/surveys`,
        signal,
      })

      const surveys_data = surveys.data.data

      if (selected_measure_object.id_scope_type === 2) {
        dimensions = await fetchGlobalApi({
          method: "GET",
          endpoint: `reports/measure/${this.state.selectedMedition}/divisions/${division_info.id_division}/dimensions?id_segment=${surveys_data[0].measure_id_segment}`,
          signal,
        })
        this.setState({ selectedSurvey: surveys_data[0].measure_id_segment })
      } else {
        dimensions = await fetchGlobalApi({
          method: "GET",
          endpoint: `reports/measure/${this.state.selectedMedition}/divisions/${division_info.id_division}/dimensions`,
          signal,
        })
      }

      const { questions } = dimensions.data.metric_total
      questions.map((e) => {
        return (e.id = parseInt(
          e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
        ))
      })

      const dimensions_data = dimensions.data.data.filter(
        (d) => d.engagement === false
      )

      let result = generateTree("id", "id_parent", [
        ...JSON.parse(JSON.stringify(dimensions_data)),
        // ...JSON.parse( JSON.stringify(questions.filter((d) => d.engagement === false)) ),
      ])
      result.forEach(addLevel(1))
      result = orderBy(result, "percent", "asc")
      if (currentAmbassador && !this.is_new) {
        this.id_profile_ambassador = null
      }
      await this.loadBasicData({
        division: division_info.id_division,
        medition: this.state.selectedMedition,
        currentAmbassador,
        signal,
      })
      this.setState(
        {
          dimensions: result,
          loadingDimensions: false,
          modal: false,
          modalDimensions: viewModal ? true : !!secondStep,
          view: viewModal ? true : !secondStep,
          loadingEditable: false,
          surveys: surveys_data,
          loadingResults: false,
          loadingButton: false,
          loadingButtonIa: false,
          loadingButtonNormal: false,
        },
        () => {
          setTimeout(() => {
            overflowTreeSelect(".dimension-action-plan-create-modal")
          }, 1000)
        }
      )
    } catch (error) {
      if (axios.isCancel(error)) return
      console.log(error)
      this.setState({ loadingDimensions: false })
      this.setState({ loadingResults: false })
    }
  }

  loadRecommendations = async () => {
    this.setState({
      loadingRecommendations: true,
      recommendations: [],
    })
    try {
      const result = await getUtilsActionPlanApi({
        searchByIdMeasure: this.state.selectedMedition,
        searchByIdDivisionAmbassadors: this.state.selectedDivision.id_division,
        id_ambassador_profile_filter: this.id_profile_ambassador,
        dimensions: this.state.dimensionsToRecommendations,
      })
      this.setState({
        loadingRecommendations: false,
        recommendations: result.data.data.result.recommendations,
      })
    } catch (error) {
      this.setState({ loadingRecommendations: false })
    }
  }

  cancelModal = () => {
    this.cancelPendingRequests()

    const {
      form: { resetFields },
    } = this.props

    resetFields()
    this.setState(
      {
        modal: false,
        modalDimensions: false,
        view: this.state.viewModalAction ? true : false,
        modalClose: false,
        loadingMeditions: true,
        modalPreview: false,
        pdaData: [],
        pdaDataStorage: [],
        indexPdaData: 0,
      },
      () => {
        // Pondremos un setTimeOut para no mostrar cambios en la vista hasta que se oculte el modal.
        setTimeout(() => {
          this.setState(
            {
              selectedDivision: this.state.viewModalAction
                ? this.state.selectedDivision
                : null,
              selectedDimension: this.state.viewModalAction
                ? this.state.selectedDimension
                : [],
              selectedMedition: this.state.viewModalAction
                ? this.state.selectedMedition
                : null,
              selectedAmbassador: this.state.viewModalAction
                ? this.state.selectedAmbassador
                : null,
              divisions: this.state.viewModalAction ? this.state.divisions : [],
              ambassadors: this.state.viewModalAction
                ? this.state.ambassadors
                : [],
              loadingSave: false,
              name: this.state.viewModalAction ? this.state.name : "",
              description: this.state.viewModalAction
                ? this.state.description
                : "",
              linkTitle: this.state.viewModalAction ? this.state.linkTitle : "",
              linkDescription: this.state.viewModalAction
                ? this.state.linkDescription
                : "",
              evidences: this.state.evidences,
              evidencesDelete:this.state.evidencesDelete,
              openDimensions: this.state.viewModalAction
                ? this.state.openDimensions
                : [],
              taskCreate: false,
              tasks: this.state.viewModalAction ? this.state.tasks : [],
              modalReplaceRecommendation: false,
              loadingRecommendations: false,
              recommendations: this.state.viewModalAction
                ? this.state.recommendations
                : [],
              dimensionsToRecommendations: this.state.viewModalAction
                ? this.state.dimensionsToRecommendations
                : [],
              recommendation_selected: this.state.viewModalAction
                ? this.state.recommendation_selected
                : {},
              temporalRecommendation: this.state.viewModalAction
                ? this.state.temporalRecommendation
                : {},
            },
            () => {
              this.props.onCancel({})
            }
          )
        }, 250)
      }
    )
  }

  backModalDimension = () => {
    this.setState(
      {
        loadingButton: false,
        disableButtonGenerate: true,
      },
      () => {
        this.setState({
          modal: true,
          modalDimensions: false,
        })
      }
    )

    if (this.state.modalActionPlanCreateNormal) {
      this.props.setStateFromTracking("modalActionPlanCreateIa", false)
    }
  }
  backModalPreview = () => {
    this.setState({
      modalDimensions: true,
      modalPreview: false,
      selectedDimension: this.state.viewModalAction
        ? this.state.selectRowsDimensions
        : this.state.selectedDimension,
    })
  }

  clickDimension = (item) => {
    const { openDimensions } = this.state
    const index = openDimensions.findIndex((e) => e === item.id_dimension)
    if (index > -1) {
      openDimensions.splice(index, 1)
      const indexChilds = recursiveFindChildsId([], item)
      indexChilds.map((iC) => {
        const indexChild = openDimensions.findIndex((e) => e === iC)
        if (indexChild > -1) {
          openDimensions.splice(indexChild, 1)
        }
      })
    } else {
      openDimensions.push(item.id_dimension)
    }
    this.setState({ openDimensions })
  }

  selectDimension = (item) => {
    const { selectedDimension } = this.state
    const index = selectedDimension.findIndex((e) => e === item)
    if (index > -1) {
      selectedDimension.splice(index, 1)
    } else {
      selectedDimension.push(item)
    }
    this.setState({ selectedDimension })
  }
  generateIA = async () => {
    await this.getActionPlanIa()

    const clickRegenerate = this.state.clickRegenerate
    const newclickRegenerate = clickRegenerate + 1
    const newIndex = this.state.indexPdaData

    this.setState({ clickRegenerate: newclickRegenerate })

    if (newIndex == 6) {
      this.setState({ indexPdaData: 0 })
    }

    const newData = {
      ...this.state.pdaDataStorage[newIndex],
      selected: true,
    }

    let updatedData = [...this.state.pdaData]

    if (updatedData.length >= 6) {
      updatedData.pop()
    }

    updatedData.forEach((item) => {
      item.selected = false
    })

    updatedData.unshift(newData)

    this.setState({ pdaData: updatedData })

    if (clickRegenerate === 3 && newIndex != 6) {
      this.setState({ disableButtonRegenerate: true })
      setTimeout(() => {
        this.setState({ disableButtonRegenerate: false })
      }, 120000)
      this.setState({ clickRegenerate: 1 })
    }
  }

  handleOk = () => {
    woopraTrack("Confirmar crear plan de acción")
    this.setDimensionsToRecommendations()
    this.setStateFrom({
      newTasks: [],
    })
    if (this.state.modalPreview) {
      this.selectedPDAIA()
    }
    this.setState({
      modalPreview: false,
      modalDimensions: false,
      view: true,
      selectedDimension: this.state.viewModalAction
        ? this.state.selectRowsDimensions
        : this.state.selectedDimension,
    })
  }
  handlePreview = async () => {
    if (
      this.state.selectedDimensionMemory != this.state.selectedDimension[0] ||
      this.state.selectedDivisionMemory !=
        this.state.selectedDivision.id_division ||
      this.state.selectedMeditionMemory != this.state.selectedMedition ||
      this.state.pdaDataStorage.length == 0 ||
      this.state.pdaFail
    ) {
      this.setState(
        {
          selectedDivisionMemory: this.state.selectedDivision.id_division,
          selectedDimensionMemory: this.state.selectedDimension,
          selectedMeditionMemory: this.state.selectedMedition,
          pdaData: [],
          pdaDataStorage: [],
          selectedAmbassador: this.state.ambassadors[0],
        },
        async () => {
          await this.getActionPlanIa("false")
          if (this.state.pdaData.length > 0) {
            this.setState({
              modalDimensions: false,
              modalPreview: true,
            })
          } else {
            this.setState({ loadingPdaIA: false })
          }
        }
      )
    } else {
      this.setState({
        modalDimensions: false,
        modalPreview: true,
        loadingPdaIA: false,
      })
    }
  }

  selectedPDAIA = () => {
    const newPdaData = this.state.pdaData.filter(
      (item) => item.selected === true
    )

    this.setState({
      name: newPdaData[0].nombreDePlan,
      description: newPdaData[0].descripcion,
    })

    const acciones = newPdaData[0].acciones

    for (let i = 0; i < acciones.length; i++) {
      this.setState((prevState) => {
        return {
          newTasks: [
            ...prevState.newTasks,
            {
              id: uuid(),
              employees: { ...this.state.selectedAmbassador },
              name: acciones[i].accion,
            },
          ],
        }
      })
    }
  }

  getActionPlanIa = async (regenerate = "true") => {
    try {
      this.setState({ loadingPdaIA: true, pdaFail: false })
      const pdasData = await getActionPlansWithIa({
        id_dimension: this.state.id_dimension,
        id_company: this.state.id_company,
        id_division: this.state.selectedDivision.id_division,
        id_measure: this.state.selectedMedition,
        id_dimension_parent: this.state.id_dimension_parent,
        result: this.state.value_visible,
        regenerate: regenerate,
      })
      if (pdasData.status == 200) {
        if (
          this.state.pdaData.length == 0 ||
          pdasData.data.data.result.pdas_counter == 0
        ) {
          this.setState((prevState) => {
            if (prevState.pdaDataStorage.length > 0) {
              return {
                pdaDataStorage: [
                  ...(JSON.parse(pdasData.data.data.result.content_output) ||
                    []),
                  ...prevState.pdaDataStorage,
                ],
                indexPdaData: pdasData.data.data.result.pdas_counter,
              }
            } else {
              return {
                pdaDataStorage: [
                  ...prevState.pdaDataStorage,
                  ...(JSON.parse(pdasData.data.data.result.content_output) ||
                    []),
                ],
                indexPdaData: pdasData.data.data.result.pdas_counter,
              }
            }
          })

          if (this.state.pdaData.length == 0) {
            this.setState({
              pdaData: [
                {
                  ...this.state.pdaDataStorage[this.state.indexPdaData],
                  selected: true,
                },
              ],
            })
          }
          this.setState({ loadingPdaIA: false })
        } else {
          this.setState({
            indexPdaData: pdasData.data.data.result.pdas_counter,
            loadingPdaIA: false,
          })
        }
      }
    } catch (error) {
      this.setState({
        pdaFail: true,
        loadingPdaIA: false,
        modalPreview: true,
        modalDimensions: false,
      })
      console.error("Error al obtener los planes de acción:", error)
    }
  }

  addTask = (params) => {
    const { tasks } = this.state
    tasks.push(params)
    this.setState({ tasks })
  }

  editTask = (params, index) => {
    const { tasks } = this.state
    tasks[index] = params
    this.setState({ tasks })
  }

  setSelectedAmbassadorToEmployees = (item) => {
    if (!item) return false
    const { employees, tasks } = this.state
    const verifyExist = employees.find(
      (e) => e.id_employee === item.id_employee
    )
    if (!verifyExist) {
      item.picture_profile = item.profile_picture
      employees.unshift(item)
    }
    this.setState({ employees })
    const newTasks = tasks.map((t) => {
      if (t.id_employee === null) {
        t.id_employee = item.id_employee
      }
      return t
    })

    this.setState({ tasks: newTasks })
  }

  verifyIfEngagement = () => {
    const { meditions, selectedMedition } = this.state
    if (selectedMedition) {
      const find = meditions.find((e) => e.id_measure === selectedMedition)
      if (find) {
        return !!find.is_engagement
      }
    }
    return false
  }

  saveActionPlan = async () => {
    const {
      name,
      description,
      evidences,
      selectedAmbassador,
      selectedDimension,
      selectedDivision,
      selectedMedition,
      actionPlanEditInfo,
      tasks,
      recommendation_selected,
      evidencesDelete
    } = this.state
    this.setState({ loadingSave: true, viewModalAction: false })
    try {
      const taskSend = JSON.parse(JSON.stringify(tasks)).map((e) => {
        e.date_end = moment(e.date_end, ["DD/MM/YYYY", "YYYY-MM-DD"]).format(
          "YYYY-MM-DD"
        )
        e.id_employee =
          e.employees && e.employees.length > 0
            ? e.employees[0].id_employee
            : null
        if (e.periodicity !== 0) {
          e.date_start = e.date_start
            ? moment(e.date_start, ["DD/MM/YYYY", "YYYY-MM-DD"]).format(
                "YYYY-MM-DD"
              )
            : null
          e.task_schedules = e.task_schedules.map((task) => {
            if (typeof task === "object") {
              return {
                task_date: moment(task.task_date, [
                  "DD-MM-YYYY",
                  "YYYY-MM-DD",
                ]).format("YYYY-MM-DD"),
                done: task.done || false,
              }
            }
            return task
          })
        } else {
          // Si no hay periodicidad, eliminamos lo que no necesitamos
          delete e.date_start
          delete e.task_schedules
        }
        return e
      })

      const save = await saveActionPlanApi({
        id: actionPlanEditInfo.id_action_plan || null,
        name,
        description,
        evidences,
        evidencesDelete,
        archived: actionPlanEditInfo.archived || 0,
        history: 0,
        status: actionPlanEditInfo.status || 1,
        id_ambassador: selectedAmbassador.id_ambassador,
        id_division: selectedDivision.id_division,
        id_measure: selectedMedition,
        dimensions: flatMap(selectedDimension, (item) => {
          return { id_dimension: item }
        }),
        tasks: taskSend,
        id_recommendation: recommendation_selected.id_recommendation || null,
        generate_by_ia: this.props.modalActionPlanCreateIa,
        is_dashboard: this.props.is_dashboard,
      })
      // [Wootric disabled]
      // const isEmbedded = window.top !== window.self
      // if (this.props.modalActionPlanCreateIa && !isEmbedded && typeof window.wootric === 'function') {
      //   window.wootricSettings = {
      //     email: LOCAL_USER_EMAIL(),
      //     created_at: Math.round(new Date().getTime() / 1000),
      //     account_token: "NPS-EU-84f7b7f9",
      //     properties: {
      //       stage: process.env.STAGE,
      //       company: LOCAL_COMPANY_NAME() || "",
      //       role: LOCAL_ACTIVE_ROL_NAME() || "",
      //       hubspot: LOCAL_COMPANY_HUBSPOT() || "",
      //     },
      //   }
      //   wootricSettings.event_name = this.props.is_dashboard
      //     ? "Crear plan con IA - Desde Previsualización"
      //     : 'Crear plan con IA - Desde Botón "Generar plan con IA"'
      //
      //   window.wootric("run")
      //   window.wootric.alreadyRunning = true
      // }
      this.cancelModal()
      this.props.finish({})
      returnMessage(save)
    } catch (error) {
      this.setState({ loadingSave: false })
      returnMessage(error)
    }
  }

  renderSelectMeditions = () => {
    const { selectedMedition, loadingMeditions, meditions } = this.state
    return (
      <Fragment>
        <p>
          {this.intl.modalActionPlanCreate.selection.firstText}{" "}
          <b>{this.intl.modalActionPlanCreate.selection.measure}</b>{" "}
          {this.intl.modalActionPlanCreate.selection.secondText}
        </p>
        <Select
          onChange={(selectedMedition) => {
            this.setState(
              {
                selectedMedition: selectedMedition.id_measure,
                loadingDivisions: true,
                selectedDivision: null,
                selectedMeditionObject: selectedMedition,
              },
              () => {
                this.loadBasicData({ medition: selectedMedition.id_measure })
              }
            )
          }}
          options={meditions}
          labelKey="id_measure"
          label="name"
          id="dropdownMedicion"
          style={{ width: 300, marginBottom: 10 }}
          value={selectedMedition || null}
          placeholder={this.intl.modalActionPlanCreate.placeholder.measure}
          isLoading={loadingMeditions}
        />
      </Fragment>
    )
  }

  renderSelectDivisions = () => {
    const {
      selectedMedition,
      selectedDivision,
      loadingDivisions,
      divisions,
    } = this.state
    return (
      <Fragment>
        <p>
          {this.intl.modalActionPlanCreate.selection.firstText}{" "}
          <b>{this.intl.modalActionPlanCreate.selection.division}</b>{" "}
          {this.intl.modalActionPlanCreate.selection.secondText}
        </p>
        <Select
          onChange={(selectedDivision) => {
            this.setState({
              selectedDivision,
              secondStep: selectedDivision ? selectedDivision.anonymity : false,
            })
          }}
          options={divisions}
          labelKey="id_division"
          label="division_name"
          style={{ width: 300 }}
          placeholder={this.intl.modalActionPlanCreate.placeholder.division}
          id="dropdownDivision"
          disabled={
            selectedMedition
              ? !(divisions.length >= 0 && !loadingDivisions)
              : true
          }
          value={selectedDivision ? selectedDivision.id_division : null}
          isLoading={loadingDivisions}
        />
      </Fragment>
    )
  }

  firstModal = () => {
    return (
      <Fragment>
        {this.renderSelectMeditions()}
        {this.renderSelectDivisions()}
      </Fragment>
    )
  }

  setDimensionsToRecommendations = () => {
    const { dimensions, selectedDimension } = this.state
    const dimensions_flattern = []

    const flatten = (array) => {
      array.forEach((obj) => {
        const name = {
          dimension_name: obj.dimension_name,
          id_dimension: obj.id_dimension,
        }
        if (obj.dimension_name) dimensions_flattern.push(name)
        if (obj.childs) {
          flatten(obj.childs)
        }
      })
      return dimensions_flattern
    }

    const listDimensions = flatten(dimensions)

    let toRecommendations = listDimensions.filter((e) => {
      if (selectedDimension.includes(e.id_dimension)) {
        return e
      }
    })
    toRecommendations = flatMap(toRecommendations, (item) => {
      return { dimension_name: item.dimension_name }
    })

    if (!isEqual(this.state.dimensionsToRecommendations, toRecommendations)) {
      this.setState({ dimensionsToRecommendations: toRecommendations }, () => {
        this.loadRecommendations()
      })
    }
  }

  selectRecommendation = (recommendation) => {
    const {
      form: { resetFields },
    } = this.props
    const { recommendation_selected } = this.state
    resetFields()
    if (
      recommendation_selected.id_recommendation ===
      recommendation.id_recommendation
    ) {
      return this.setState({
        recommendation_selected: {},
        name: "",
        description: "",
        tasks: [],
      })
    }
    return this.setState({
      recommendation_selected: recommendation,
      name: recommendation.name,
      description: recommendation.description,
      tasks: recommendation.tasks.map((e) => {
        e.task_schedules = []
        e.edit = true
        e.is_recommendation = true
        return e
      }),
    })
  }

  renderModalFreemium = () => {
    return (
      <ModalCustom
        modalOpen
        showFooter
        onOk={() => {
          requestUpgradeApi()
          this.cancelModal()
        }}
        textButton="Contactar al equipo comercial"
        onCancel={this.cancelModal}
        width={607}
        textCancelButton="Cerrar">
        <div className="text-left">
          <img
            style={{
              margin: "-21px -24px 20px",
              width: "calc(100% + 48px)",
              minHeight: 370,
            }}
            src={imgCreateActionPlan}
          />
          <p className="font-size-16">
            <b>
              Lo sentimos, pero no cuentas con acceso para generar planes de
              acción 😢
            </b>
          </p>
          <p className="font-size-15">
            En esta sección podrás generar <b>planes de acción</b> para trabajar
            sobre tus resultados.
          </p>
          <ul
            className="font-size-15 list-bullet-blue"
            style={{ padding: "0 14px" }}>
            <li>
              Podrás direccionar el plan de acción hacia{" "}
              <b>dimensiones específicas</b>.
            </li>
            <li>
              Podrás <b>crear tareas</b> asignadas a distintos usuarios, y{" "}
              <b>monitorear su progreso en el tiempo</b>.
            </li>
            <li>
              Podrás crear <b>recomendaciones</b> que luego podrán ser
              utilizadas por el resto de usuarios en tu organización.
            </li>
          </ul>
        </div>
      </ModalCustom>
    )
  }

  /* Refactorizar esto pronto 28-07 */

  handleClickOutside = (event) => {
    /* const verify = event.target.closest(".container-header")
    if (verify) {
      const test = event.target
    } */
  }
  editEvidence = (id) => {
    this.setState(
      (prevState) => ({
        evidences: prevState.evidences.map((ev) =>
          ev.id === id ? { ...ev, isEditing: true } : ev
        ),
      }),
      () => {
        const el = document.getElementById(`evidenceEdit-${id}`)
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          })
        }
      }
    )
  }

  removeEvidence = (id) => {
    this.setState({
      modalDeleteEvidence: true,
      evidenceToDeleteId: id,
    })
  }
  handleConfirmDeleteEvidence = () => {
    if(!navigator.onLine){
      this.setState({ modalDeleteEvidence: false, evidenceToDeleteId: null })
      message.error(this.intl.modalActionPlanCreate.createModal.evidence.errorDeleteEvidence)
      return;
    }
    
    this.setState((prev) => ({
      evidences: prev.evidences.filter(
        (e) => e.id !== prev.evidenceToDeleteId
      ),
      modalDeleteEvidence: false,
      evidenceToDeleteId: null,
    }))
    this.setState({
      evidencesDelete: [
        ...this.state.evidencesDelete,
        this.state.evidenceToDeleteId
      ]
    });
    
    message.success(this.intl.modalActionPlanCreate.createModal.evidence.deleteEvidenceSuccess)
    
  }

  // Cancelar
  handleCancelDeleteEvidence = () => {
    this.setState({
      modalDeleteEvidence: false,
      evidenceToDeleteId: null,
    })
  }
  onUpdateEvidence = (id) => {
    this.setState((prevState) => ({
      evidences: prevState.evidences.map((ev) =>
        ev.id === id ? { ...ev, isEditing: false } : ev
      ),
    }))
  }
  render() {
    const {
      modal,
      modalDimensions,
      modalPreview,
      dimensions,
      loadingDimensions,
      openDimensions,
      selectedDivision,
      selectedMedition,
      selectedDimension,
      view,
      ambassadors,
      selectedAmbassador,
      name,
      description,
      linkTitle,
      linkDescription,
      loadingSave,
      secondStep,
      taskCreate,
      tasks,
      loadingEditable,
      employees,
      currentTask,
      modalDeleteTaks,
      loadingRecommendations,
      recommendations,
      recommendation_selected,
      modalReplaceRecommendation,
      temporalRecommendation,
      modalClose,
      loadingAmbassadors,
      selectedSurvey,
      loadingDivisions,
      divisions,
      selectedMeditionObject,
      loadingButton,
      loadingButtonIa,
      loadingButtonNormal,
      dashboard_enter,
      loadingDimensionsWithIa,
      loadingPdaIA,
      pdaFail,
    } = this.state
    const {
      form: { getFieldDecorator, resetFields, validateFieldsAndScroll },
      modalActionPlanEditId,
      modalActionPlanCreateIa,
      modalActionPlanCreateNormal,
    } = this.props
    const isFreemium = window.freemium()
    let widthM =
      selectedMeditionObject &&
      selectedMeditionObject.is_engagement == 1 &&
      selectedMeditionObject.id_scope_type == 1
        ? 800
        : 700
    if (isFreemium && (modal || modalDimensions || view)) {
      return this.renderModalFreemium()
    }
    const antIcon = (
      <LoadingOutlined
        style={{
          fontSize: 12,
        }}
        spin
      />
    )
    const customSpinnerStyle = {
      fontSize: "12px",
      verticalAlign: "middle",
      bottom: "8px",
    }
    const viewModal = true

    const modalTable = this.state.viewModalAction
      ? true
      : !modalActionPlanEditId
    const isEmbedded = window.top !== window.self
    return (
      <Fragment>
        {view && (
          <div
            className="ModalACtionPlanCreate-component-blockHeader"
            onClick={() =>
              this.setState({
                modalClose: true,
              })
            }
          />
        )}
        <Modal
          className={`${
            modalActionPlanCreateIa
              ? "create-header-pda-ia especial-button"
              : "especial-button"
          }`}
          onCancel={() => {
            this.setState({ loadingButton: false }), this.cancelModal()
          }}
          maskClosable={true}
          open={modal && !modalActionPlanEditId}
          title={
            !modalActionPlanCreateIa ? (
              this.intl.modalActionPlanCreate.title
            ) : (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  height: "20px",
                }}>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    marginTop: 5,
                  }}>
                  <span style={{ color: "#55C8AE", marginRight: 8 }}>
                    {" "}
                    {this.intl.modalActionPlanCreate.titleIa}
                  </span>
                  <IconoVaritaMagica fill={"#55C8AE"} />{" "}
                </div>
                <div>
                  <img
                    src={iconX}
                    onClick={() => {
                      this.cancelModal()
                    }}
                    style={{
                      marginLeft: 5,
                      marginBottom: 2,
                      cursor: "pointer",
                    }}
                    alt="x-icon"
                  />
                </div>
              </div>
            )
          }
          closable={false}
          width={520}
          footer={
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "space-between",
              }}>
              <div>
                {modalActionPlanCreateNormal && LOCAL_PDA_IA_ENABLED() && (
                  <div>
                    <Tooltip
                      style={{ marginRight: 8 }}
                      title={
                        LOCAL_AI_LIMIT_REACHED() ? (
                          "Sin créditos disponibles. Por favor contacta al administrador de tu empresa."
                        ) : (
                          <Fragment>
                            {
                              this.intl.previewActionPlanIA
                                .tooltipContinueUseIaOne
                            }
                            <br />
                            {
                              this.intl.previewActionPlanIA
                                .tooltipContinueUseIaTwo
                            }
                          </Fragment>
                        )
                      }
                      trigger="hover"
                      overlayClassName="tooltipWhitePda">
                      <Button
                        type="primary"
                        loading={
                          this.props.fromAnalysis
                            ? false
                            : !modalActionPlanCreateIa
                            ? false
                            : loadingDimensions
                        }
                        style={
                          LOCAL_AI_LIMIT_REACHED()
                            ? { marginRight: 8, background: "#e6e6e6", borderColor: "#e6e6e6", color: "#6f6f6f" }
                            : {
                                marginRight: 8,
                                background: "#55C8AE",
                                borderColor: "#55C8AE",
                                color: "white",
                                opacity: !selectedMedition || !selectedDivision || loadingButtonNormal ? 0.6 : 1,
                              }
                        }
                        disabled={
                          !selectedMedition ||
                          !selectedDivision ||
                          loadingButtonNormal ||
                          LOCAL_AI_LIMIT_REACHED()
                        }
                        onClick={() => {
                          if (modalActionPlanCreateNormal) {
                            this.setState({ loadingButtonIa: true })

                            this.props.setStateFromTracking(
                              "modalActionPlanCreateIa",
                              true
                            )
                          }

                          this.loadDimensions(secondStep, null, false)
                        }}>
                        <IconoVaritaMagica
                          fill={LOCAL_AI_LIMIT_REACHED() ? "#6f6f6f" : "#FFFFFF"}
                        />
                        <span style={{ marginLeft: 7 }}>
                          {this.intl.modalActionPlanCreate.actions.titleIa}
                        </span>
                      </Button>{" "}
                    </Tooltip>
                  </div>
                )}
              </div>
              <div>
                <Button
                  key="backInit"
                  onClick={() => {
                    this.setState({ loadingButton: false })
                    woopraTrack("Cancelar Crear plan de acción")
                    this.cancelModal()
                  }}>
                  {this.intl.modalActionPlanCreate.actions.cancel}
                </Button>
                <Tooltip
                  style={{ marginRight: 8 }}
                  title={
                    modalActionPlanCreateNormal ? (
                      <Fragment>
                        {
                          this.intl.previewActionPlanIA
                            .tooltipContinueUseNormalOne
                        }
                        <br />
                        {
                          this.intl.previewActionPlanIA
                            .tooltipContinueUseNormalTwo
                        }
                      </Fragment>
                    ) : (
                      ""
                    )
                  }
                  trigger="hover"
                  overlayClassName="tooltipWhitePda">
                  <Button
                    loading={
                      !loadingButtonIa
                        ? this.props.fromAnalysis
                          ? loadingButton
                          : loadingDimensions
                        : false
                    }
                    disabled={
                      !selectedMedition || !selectedDivision || loadingButtonIa
                    }
                    key="submitInit"
                    type="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      this.setState({
                        loadingButtonNormal: true,
                        disableButtonGenerate: true,
                      })

                      if (this.props.fromAnalysis) {
                        this.setState({ loadingButton: true })
                      }

                      this.loadDimensions(secondStep)
                      if (modalActionPlanCreateNormal) {
                        this.props.setStateFromTracking(
                          "modalActionPlanCreateIa",
                          false
                        )
                      }
                    }}>
                    {this.intl.modalActionPlanCreate.actions.select}
                  </Button>
                </Tooltip>
              </div>
            </div>
          }
          bodyStyle={{ fontSize: 13 }}>
          {this.firstModal()}
        </Modal>

        <Modal
          className={`${
            modalActionPlanCreateIa && !this.state.viewModalAction
              ? "create-header-pda-ia-second especial-button"
              : "especial-button"
          }`}
          width={widthM}
          visible={modalDimensions && modalTable}
          title={
            this.state.viewModalAction ? (
              getLanguage() == "es" ? (
                `${this.intl.modalActionPlanCreate.selection.resultsOf}  ${this.state.selectedMeditionObject.name} - Division: ${selectedDivision.division_name}`
              ) : (
                `${this.state.selectedMeditionObject.name} ${this.intl.modalActionPlanCreate.selection.resultsOf} - Division: ${selectedDivision.division_name}`
              )
            ) : !modalActionPlanCreateIa ? (
              this.intl.modalActionPlanCreate.title
            ) : (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  height: "20px",
                }}>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    marginTop: 5,
                  }}>
                  <span style={{ color: "#55C8AE", marginRight: 8 }}>
                    {" "}
                    {this.intl.modalActionPlanCreate.titleIa}
                  </span>{" "}
                  <IconoVaritaMagica fill={"#55C8AE"} />{" "}
                </div>
                <div>
                  <img
                    src={iconX}
                    onClick={() => {
                      this.cancelModal()
                    }}
                    style={{
                      marginLeft: 5,
                      marginBottom: 2,
                      cursor: "pointer",
                    }}
                    alt="x-icon"
                  />
                </div>
              </div>
            )
          }
          closable={false}
          onCancel={() => {
            this.cancelModal()
          }}
          maskClosable={true}
          footer={
            <div style={{ display: "flex" }}>
              {!this.state.viewModalAction && (
                <Button
                  key="previus"
                  onClick={() => {
                    this.backModalDimension()
                  }}
                  style={{ marginRight: "auto" }}>
                  &lt; {this.intl.modalActionPlanCreate.actions.back}
                </Button>
              )}
              <div style={{ marginLeft: "auto" }}>
                <Button key="back" onClick={this.cancelModal}>
                  {this.intl.modalActionPlanCreate.actions.cancel}
                </Button>
                <Tooltip
                  style={{ marginRight: 8, marginBottom: 2 }}
                  title={
                    this.state.disableButtonRegenerate ? (
                      <div>
                        {this.intl.previewActionPlanIA.tooltipRegenerateOne}
                        <br />
                        {sanitize(
                          this.intl.previewActionPlanIA.tooltipRegenerateTwo
                        )}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  trigger="hover"
                  overlayClassName="tooltipWhitePda"
                  defaultOpen>
                  <Button
                    key="submit"
                    type="primary"
                    className="button-spacing"
                    loading={loadingDimensions}
                    disabled={
                      this.state.disabledSubmit ||
                      this.state.disableButtonRegenerate ||
                      this.state.disableButtonGenerate
                    }
                    onClick={
                      !modalActionPlanCreateIa || this.state.viewModalAction
                        ? this.handleOk
                        : this.handlePreview
                    }>
                    {this.state.viewModalAction ? (
                      this.intl.modalActionPlanCreate.actions.save
                    ) : !modalActionPlanCreateIa ? (
                      this.intl.modalActionPlanCreate.actions.create
                    ) : (
                      <div>
                        <div style={{ marginRight: 8, display: "inline" }}>
                          <IconoVaritaMagica
                            fill={
                              this.state.disableButtonRegenerate ||
                              this.state.disableButtonGenerate
                                ? "#C4C4C4"
                                : "#FFFFFF"
                            }
                          />
                        </div>
                        {this.intl.modalActionPlanCreate.actions.generateIa}
                      </div>
                    )}
                  </Button>
                </Tooltip>
              </div>
            </div>
          }
          bodyStyle={{ fontSize: 13 }}>
          <p>
            {modalActionPlanCreateIa
              ? this.intl.modalActionPlanCreate.selection.firstTextSingular
              : this.intl.modalActionPlanCreate.selection.firstTextPlural}{" "}
            <b>
              {" "}
              {modalActionPlanCreateIa
                ? this.intl.modalActionPlanCreate.selection
                    .dimensionsSubdimensionSingular
                : this.intl.modalActionPlanCreate.selection
                    .dimensionsSubdimensions}{" "}
            </b>{" "}
            {this.intl.modalActionPlanCreate.selection.secondAlterText}
          </p>
          {this.state.selectedMeditionObject &&
            this.state.selectedMeditionObject.id_scope_type === 2 &&
            this.state.surveys &&
            this.state.surveys.length > 1 && (
              <div>
                <span>
                  <b style={{ color: "#4F4F4F" }}>
                    {this.intl.modalActionPlanCreate.survey}
                    {":"}
                  </b>
                </span>
                <AntdSelect
                  placeholder="Selecciona un cuestionario"
                  style={{ width: 300, color: "#4F4F4F" }}
                  defaultValue={this.state.surveys[0].measure_id_segment}
                  value={this.state.selectedSurvey}
                  onChange={(selectedSurvey) => {
                    this.setState(
                      {
                        selectedSurvey,
                      },
                      () => {
                        this.nextLoadDimensions()
                      }
                    )
                  }}>
                  {this.state.surveys &&
                    this.state.surveys.map((survey) => (
                      <AntdSelect.Option
                        value={survey.measure_id_segment}
                        key={survey.measure_id_segment}>
                        {survey.survey_name} - {survey.measure_segment_name}
                      </AntdSelect.Option>
                    ))}
                </AntdSelect>
              </div>
            )}
          <div className="ModalACtionPlanCreate-component-dimensions">
            {
              <ResultByDimensionActionPlan
                data={this.state.dimensions}
                selectedMeditionObject={this.state.selectedMeditionObject}
                setStateFrom={this.setStateFrom}
                selectedDimension={this.state.selectedDimension}
                viewModalAction={this.state.viewModalAction}
                disabledSubmit={this.state.disabledSubmit}
                modalActionPlanCreateIa={modalActionPlanCreateIa}
              />
            }
            {loadingPdaIA && (
              <div className="loadingSpinOverlayPda">
                <div className="loadingSpin">
                  <Spin size="large" />
                </div>
              </div>
            )}
            {/* <ResultByDimensionV2
                hideMessageLess25
                hideIcons
                showCheckbox
                hideHeaders={[]}
                isLoading={loadingDimensions}
                openDimensions={openDimensions}
                data={dimensions}
                selectedDimension={selectedDimension}
                clickDimension={(e) => this.clickDimension(e)}
                onSelectDimension={(d) => this.selectDimension(d)}
                showColumnImpact={this.verifyIfEngagement()}
              /> */}
          </div>
        </Modal>

        {modalPreview && (
          <Modal
            className={
              "create-header-pda-ia-three create-body-pda-ia especial-button"
            }
            width={!pdaFail ? 920 : 700}
            visible={modalPreview}
            title={
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  height: "20px",
                }}>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    marginTop: 5,
                  }}>
                  <span style={{ color: "#55C8AE", marginRight: 8 }}>
                    {" "}
                    {this.intl.modalActionPlanCreate.titleIa}
                  </span>{" "}
                  <IconoVaritaMagica fill={"#55C8AE"} />{" "}
                </div>
                <div>
                  <img
                    src={iconX}
                    onClick={() => {
                      this.cancelModal()
                    }}
                    style={{
                      marginLeft: 5,
                      marginBottom: 2,
                      cursor: "pointer",
                    }}
                    alt="x-icon"
                  />
                </div>
              </div>
            }
            closable={false}
            onCancel={() => {
              this.cancelModal()
            }}
            maskClosable={true}
            footer={
              <div style={{ display: "flex" }}>
                {!this.state.viewModalAction && !dashboard_enter && (
                  <Button
                    key="previus"
                    onClick={this.backModalPreview}
                    style={{ marginRight: "auto" }}>
                    &lt; {this.intl.modalActionPlanCreate.actions.back}
                  </Button>
                )}
                <div style={{ marginLeft: "auto" }}>
                  <Button key="back" onClick={this.cancelModal}>
                    {this.intl.modalActionPlanCreate.actions.cancel}
                  </Button>

                  {!pdaFail && (
                    <Tooltip
                      style={{ marginRight: 8, marginBottom: 2 }}
                      title={
                        this.state.disableButtonRegenerate ? (
                          <div>
                            {this.intl.previewActionPlanIA.tooltipRegenerateOne}
                            <br />
                            {sanitize(
                              this.intl.previewActionPlanIA.tooltipRegenerateTwo
                            )}
                          </div>
                        ) : (
                          ""
                        )
                      }
                      trigger="hover"
                      overlayClassName="tooltipWhitePda"
                      defaultOpen>
                      <Button
                        className="button-spacing"
                        key="regenerate"
                        disabled={this.state.disableButtonRegenerate}
                        onClick={this.generateIA}>
                        {
                          <div>
                            <div style={{ marginRight: 8, display: "inline" }}>
                              <IconoRegenerate
                                fill={
                                  this.state.disableButtonRegenerate
                                    ? "#C4C4C4"
                                    : "#2694FC"
                                }
                              />
                            </div>
                            {this.intl.modalActionPlanCreate.actions.regenerate}
                          </div>
                        }
                      </Button>
                    </Tooltip>
                  )}
                  {!pdaFail && (
                    <Button
                      key="submitIa"
                      type="primary"
                      loading={loadingDimensions || loadingDimensionsWithIa}
                      disabled={this.state.disabledSubmit}
                      onClick={() => {
                        if (dashboard_enter) {
                          this.loadDimensionsWithIA()
                        } else {
                          this.handleOk()
                        }
                      }}>
                      {
                        <div style={{ display: "inline" }}>
                          <div style={{ marginRight: 8, display: "inline" }}>
                            <IconoVaritaMagica fill={"#FFFFFF"} />
                          </div>
                          {this.intl.modalActionPlanCreate.actions.createIa}
                        </div>
                      }
                    </Button>
                  )}
                </div>
              </div>
            }
            bodyStyle={{ fontSize: 13 }}>
            {(loadingPdaIA || loadingDimensionsWithIa) && !pdaFail && (
              <div className="loadingSpinOverlayPda">
                <div className="loadingSpin">
                  <Spin size="large" />
                </div>
              </div>
            )}
            <div
              className="ModalACtionPlanCreate-component-preview"
              style={!pdaFail ? { height: "auto" } : { height: 274 }}>
              {!pdaFail && (
                <PreviewPDAWithIA
                  setStateFrom={this.setStateFrom}
                  dimension_name={this.state.dimension_name}
                  dimension_color={this.state.dimension_color}
                  value_visible={this.state.value_visible}
                  selectedDivision={this.state.selectedDivision}
                  pdaData={this.state.pdaData}
                  division_name={this.state.selectedDivision.division_name}
                />
              )}
              {pdaFail && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  <img
                    src={globo}
                    style={{ marginBottom: 8, marginTop: 28 }}
                    alt="globo"
                  />
                  <span
                    style={{ fontSize: 14, fontWeight: 600, color: "#4F4F4F" }}>
                    {this.intl.caidaOpenIa.title}
                  </span>
                  <span style={{ fontSize: 14, color: "#4F4F4F" }}>
                    {this.intl.caidaOpenIa.subTitleOne}
                  </span>
                  <span style={{ fontSize: 14, color: "#4F4F4F" }}>
                    {this.intl.caidaOpenIa.subTitleTwo}
                  </span>
                </div>
              )}
            </div>
          </Modal>
        )}

        <Fade duration={300} when={view}>
          {view && (
            <div
              className="ModalACtionPlanCreate-component-view buttonsFooter"
              style={{
                marginTop: 0,
                overflow: "auto",
                ...(isEmbedded
                  ? { top: 0, height: "100%" }
                  : { height: "calc(100% - 53px)" }),
                ...this.props.stylePdaLast,
              }}>
              {loadingEditable ? (
                <div className="loadingSpin">
                  <Spin size="large" />
                </div>
              ) : (
                <Fragment>
                  <div className="ModalACtionPlanCreate-component-view-header">
                    <h4 className="ModalACtionPlanCreate-component-view-header-title title_section">
                      {this.is_new
                        ? this.intl.modalActionPlanCreate.actions.create
                        : this.intl.modalActionPlanCreate.actions.edit}{" "}
                      {this.intl.modalActionPlanCreate.actionPlan}:{" "}
                      <span style={{ fontWeight: "normal" }}>
                        {this.state.selectedMeditionObject.name}{" "}
                        {" - " +
                          this.intl.modalActionPlanCreate.division +
                          ": "}
                        {selectedDivision
                          ? selectedDivision.division_name
                          : null}{" "}
                      </span>
                    </h4>
                  </div>
                  <div className="ModalACtionPlanCreate-component-view-content">
                    <div className="ModalACtionPlanCreate-component-view-content-columns">
                      <div className="ModalACtionPlanCreate-component-view-content-columns-left">
                        {!this.is_new && (
                          <div className="ModalACtionPlanCreate-component-view-content-columns-left-block">
                            <div>
                              <div>División: *</div>
                              <div>
                                <FormItem>
                                  {getFieldDecorator("id_division", {
                                    initialValue: selectedDivision
                                      ? selectedDivision.id_division
                                      : null,
                                    rules: [
                                      {
                                        required: true,
                                        message: formLabelMessage(
                                          "es",
                                          "required"
                                        ),
                                      },
                                    ],
                                  })(
                                    <Select
                                      onChange={(selectedDivision) => {
                                        this.setState(
                                          {
                                            selectedDivision,
                                            secondStep: selectedDivision
                                              ? selectedDivision.anonymity
                                              : false,
                                          },
                                          () => {
                                            this.loadDimensions(
                                              false,
                                              this.state.selectedAmbassador
                                            )
                                          }
                                        )
                                      }}
                                      options={divisions}
                                      labelKey="id_division"
                                      label="division_name"
                                      style={{ width: 300 }}
                                      placeholder={
                                        this.intl.modalActionPlanCreate
                                          .placeholder.division
                                      }
                                      disabled={
                                        selectedMedition
                                          ? !(
                                              divisions.length >= 0 &&
                                              !loadingDivisions
                                            )
                                          : true
                                      }
                                      isLoading={loadingDivisions}
                                    />
                                  )}
                                </FormItem>
                              </div>
                            </div>
                          </div>
                        )}
                        <div
                          className="ModalACtionPlanCreate-component-view-content-columns-left-block"
                          style={{ gridTemplateColumns: "1.5fr 1fr" }}>
                          <div>
                            <div style={{ display: "flex" }}>
                              <div style={{ flex: 1 }}>
                                {
                                  this.intl.modalActionPlanCreate.createModal
                                    .dimension
                                }
                              </div>
                              <div
                                style={{
                                  flex: 1,
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  height: "20px",
                                }}>
                                <span
                                  style={{
                                    color: "#2694FC",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    this.loadDimensions(
                                      secondStep,
                                      this.state.selectedAmbassador,
                                      viewModal
                                    )
                                  }>
                                  {
                                    this.intl.modalActionPlanCreate.selection
                                      .seeResults
                                  }
                                  {this.state.loadingResults ? (
                                    <Spin
                                      indicator={antIcon}
                                      style={customSpinnerStyle}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </div>

                            <div>
                              <FormItem>
                                {getFieldDecorator("selectedDimension", {
                                  initialValue: selectedDimension,
                                  rules: [
                                    {
                                      required: true,
                                      message: formLabelMessage(
                                        "es",
                                        "required"
                                      ),
                                    },
                                  ],
                                })(
                                  <TreeSelect
                                    placeholder={
                                      this.intl.modalActionPlanCreate
                                        .placeholder.dimensions
                                    }
                                    style={{ width: "100%" }}
                                    dropdownStyle={{ maxHeight: 250 }}
                                    showSearch
                                    multiple
                                    allowClear
                                    treeDefaultExpandAll
                                    treeNodeFilterProp="title"
                                    className="dimension-action-plan-create-modal"
                                    onChange={(s, c, extra) => {
                                      this.setState(
                                        { selectedDimension: s },
                                        () => {
                                          overflowTreeSelect(
                                            ".dimension-action-plan-create-modal"
                                          )
                                        }
                                      )
                                    }}
                                    onDropdownVisibleChange={(event) => {
                                      if (!event) {
                                        this.setDimensionsToRecommendations()
                                      }
                                    }}
                                    onDeselect={(open) => {
                                      setTimeout(() => {
                                        this.setDimensionsToRecommendations()
                                      }, 1000)
                                    }}>
                                    {dimensions.map((e) => {
                                      return (
                                        <TreeNode
                                          idSelected={e.id_dimension}
                                          value={e.id_dimension}
                                          title={e.name}
                                          key={e.id_dimension}>
                                          {e.childs &&
                                            e.childs.map((child) => {
                                              return (
                                                <TreeNode
                                                  value={child.id_dimension}
                                                  title={child.name}
                                                  key={child.id_dimension}
                                                  idSelected={
                                                    child.id_dimension
                                                  }
                                                />
                                              )
                                            })}
                                        </TreeNode>
                                      )
                                    })}
                                  </TreeSelect>
                                )}
                              </FormItem>
                            </div>
                          </div>
                          <div>
                            <div>
                              {
                                this.intl.modalActionPlanCreate.createModal
                                  .assignedTo
                              }
                            </div>
                            <div>
                              <FormItem>
                                {getFieldDecorator("selectedAmbassador", {
                                  initialValue: selectedAmbassador
                                    ? selectedAmbassador.id_ambassador
                                    : null,
                                  rules: [
                                    {
                                      required: true,
                                      message: formLabelMessage(
                                        "es",
                                        "required"
                                      ),
                                    },
                                  ],
                                })(
                                  <Select
                                    options={ambassadors}
                                    placeholder={
                                      this.intl.modalActionPlanCreate
                                        .placeholder.responsible
                                    }
                                    style={{ width: "100%" }}
                                    labelKey="id_ambassador"
                                    labelImage="profile_picture"
                                    label="full_name"
                                    disabled={loadingAmbassadors}
                                    isLoading={loadingAmbassadors}
                                    id="asignado"
                                    onChange={(selectedAmbassador) => {
                                      this.setSelectedAmbassadorToEmployees(
                                        selectedAmbassador
                                      )
                                      this.setState({ selectedAmbassador })
                                    }}
                                  />
                                )}
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div className="ModalACtionPlanCreate-component-view-content-columns-left-block">
                          <div>
                            <div>
                              {sanitize(
                                this.intl.modalActionPlanCreate.createModal
                                  .actionPlan
                              )}
                            </div>
                            <div>
                              <FormItem>
                                {getFieldDecorator("name", {
                                  initialValue: name,
                                  rules: [
                                    {
                                      required: true,
                                      message: formLabelMessage(
                                        "es",
                                        "required"
                                      ),
                                    },
                                  ],
                                })(
                                  <Input
                                    maxLength={200}
                                    placeholder={
                                      this.intl.modalActionPlanCreate
                                        .createModal.placeholders
                                        .actionPlanTitle
                                    }
                                    onChange={(e) =>
                                      this.setState({ name: e.target.value })
                                    }
                                  />
                                )}
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div className="ModalACtionPlanCreate-component-view-content-columns-left-block">
                          <div>
                            <div>
                              {
                                this.intl.modalActionPlanCreate.createModal
                                  .actionPlanDescription
                              }
                            </div>
                            <div>
                              <FormItem>
                                {getFieldDecorator("description", {
                                  initialValue: description,
                                })(
                                  <Input.TextArea
                                    maxLength={350}
                                    placeholder={
                                      this.intl.modalActionPlanCreate
                                        .createModal.placeholders
                                        .actionPlanDescription
                                    }
                                    autoSize={{ minRows: 2, maxRows: 4 }}
                                    onChange={(e) =>
                                      this.setState({
                                        description: e.target.value,
                                      })
                                    }
                                  />
                                )}
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ModalACtionPlanCreate-component-view-content-columns-left-block"
                          style={{ gridGap: 15 }}>
                          <div className="ModalACtionPlanCreate-component-view-content-columns-left-block-header">
                            <span>
                              {
                                this.intl.modalActionPlanCreate.createModal
                                  .tasks
                              }
                            </span>
                          </div>
                          {
                            <Fragment>
                              <p style={{ margin: 0 }}>
                                {
                                  this.intl.modalActionPlanCreate.createModal
                                    .tasksDescription
                                }
                              </p>
                            </Fragment>
                          }
                          {Array.isArray(this.state.newTasks) && (
                            <div style={{ display: "block" }}>
                              <Button
                                className="button_no_animation"
                                type="primary"
                                onClick={() => {
                                  woopraTrack("Agregar tarea")
                                  this.setState((prevState) => {
                                    return {
                                      taskCreate: true,
                                      newTasks: [
                                        ...prevState.newTasks,
                                        { id: uuid() },
                                      ],
                                    }
                                  })
                                }}>
                                {
                                  this.intl.modalActionPlanCreate.createModal
                                    .actions.addTask
                                }
                              </Button>
                            </div>
                          )}
                          {tasks.map((t, ti) => {
                            //const key = `task-${t.id_task}`;
                            const key = Math.random()
                              .toString(36)
                              .substring(7)
                            if (t.edit) {
                              return (
                                <ActionPlanTaskForm
                                  modalActionPlanCreateIa={
                                    this.props.modalActionPlanCreateIa
                                  }
                                  collaborators={employees}
                                  data={{ ...t }}
                                  onFinishSave={(params) => {
                                    params.edit = false
                                    params.is_recommendation = false
                                    this.editTask(params, ti)
                                  }}
                                  key={key}
                                  defaultEmployee={
                                    selectedAmbassador
                                      ? selectedAmbassador.id_employee
                                      : null
                                  }
                                  onCancel={() => {
                                    if (t.is_recommendation) {
                                      tasks.splice(ti, 1)
                                    } else {
                                      tasks[ti].edit = false
                                    }
                                    this.setState({ tasks: [...tasks] })
                                  }}
                                />
                              )
                            }
                            return (
                              <ActionPlanTaskResumen
                                onEdit={(params) => {
                                  this.setSelectedAmbassadorToEmployees(
                                    params.employees[0]
                                  )
                                  params.edit = true
                                  this.setState({
                                    currentTask: params,
                                    currentTaskIndex: ti,
                                  })
                                }}
                                onDelete={() =>
                                  this.setState({
                                    currentTaskIndex: ti,
                                    modalDeleteTaks: true,
                                  })
                                }
                                data={t}
                                onReloadActionPlan={(params) => {
                                  this.setState({ tasks: params.tasks })
                                }}
                                onReloadActionPlanTask={(task) => {
                                  let updatedTasks
                                  if (task.id_task) {
                                    updatedTasks = this.state.tasks.map((t) =>
                                      t.id_task === task.id_task ? task : t
                                    )
                                  } else {
                                    updatedTasks = [...this.state.tasks]
                                    updatedTasks[ti] = task
                                  }

                                  this.setState({ tasks: updatedTasks })
                                }}
                                key={`actionplan-task-${ti}`}
                              />
                            )
                          })}
                          {
                            <div>
                              {this.state.newTasks.map((task, index) => (
                                <ActionPlanTaskForm
                                  key={task.id}
                                  collaborators={employees}
                                  onFinishSave={(params) => {
                                    params.edit = false
                                    this.addTask(params)
                                    this.setState((prevState) => ({
                                      taskCreate: false,
                                      newTasks: prevState.newTasks.filter(
                                        (t) => t.id !== task.id
                                      ),
                                    }))
                                  }}
                                  data={task}
                                  defaultEmployee={
                                    selectedAmbassador
                                      ? selectedAmbassador.id_employee
                                      : null
                                  }
                                  onCancel={() =>
                                    this.setState((prevState) => ({
                                      taskCreate: false,
                                      newTasks: prevState.newTasks.filter(
                                        (t) => t.id !== task.id
                                      ),
                                    }))
                                  }
                                />
                              ))}
                            </div>
                          }
                        </div>
                      </div>
                      <div className="ModalACtionPlanCreate-component-view-content-columns-right">
                        <div>
                          <div className="ModalACtionPlanCreate-component-view-content-columns-right-header">
                            {
                              this.intl.modalActionPlanCreate.createModal
                                .recommendations.title
                            }{" "}
                            <Popover
                              placement="bottom"
                              content={
                                <span
                                  style={{
                                    width: 250,
                                    display: "inline-block",
                                  }}>
                                  {sanitize(
                                    this.intl.modalActionPlanCreate.createModal
                                      .recommendations.tooltip
                                  )}
                                </span>
                              }>
                              <img
                                src={questionIcon}
                                alt="question"
                                style={{ marginLeft: 4 }}
                              />
                            </Popover>
                          </div>
                          {loadingRecommendations ? (
                            <div className="loadingSpin">
                              <Spin size="large" />
                            </div>
                          ) : recommendations.length === 0 ? (
                            <div
                              className="ModalACtionPlanCreate-component-view-content-columns-right-content"
                              style={{ padding: 30 }}>
                              <Empty
                                style={{ color: "#828282" }}
                                image={emptyStateRecommendations}
                                description={
                                  <Fragment>
                                    <span
                                      style={{
                                        margin: "20px auto",
                                        display: "block",
                                      }}>
                                      {sanitize(
                                        this.intl.modalActionPlanCreate
                                          .createModal.recommendations
                                          .emptyState
                                      )}
                                    </span>
                                  </Fragment>
                                }
                              />
                            </div>
                          ) : (
                            <div className="ModalACtionPlanCreate-component-view-content-columns-right-content">
                              {recommendations.map((e) => {
                                const isSelected =
                                  e.id_recommendation ===
                                  recommendation_selected.id_recommendation

                                const clickToAction = () => {
                                  if (
                                    !isSelected &&
                                    (recommendation_selected.id_recommendation ||
                                      name.length > 0)
                                  ) {
                                    return this.setState({
                                      temporalRecommendation: e,
                                      modalReplaceRecommendation: true,
                                    })
                                  }
                                  return this.selectRecommendation(e)
                                }

                                return (
                                  <div
                                    className="ModalACtionPlanCreate-component-view-content-columns-right-content-item"
                                    key={e.id_recommendation}>
                                    <div className="ModalACtionPlanCreate-component-view-content-columns-right-content-item-icon plus">
                                      <Tooltip
                                        placement="top"
                                        title={
                                          isSelected
                                            ? "Borrar selección"
                                            : "Seleccionar"
                                        }>
                                        {isSelected ? (
                                          <MinusCircleFilled
                                            twoToneColor="#1890FF"
                                            onClick={clickToAction}
                                          />
                                        ) : (
                                          <PlusCircleTwoTone
                                            twoToneColor="#1890FF"
                                            onClick={clickToAction}
                                          />
                                        )}
                                      </Tooltip>
                                    </div>
                                    <div className="ModalACtionPlanCreate-component-view-content-columns-right-content-item-content">
                                      <Popover
                                        placement="bottomLeft"
                                        content={
                                          <div
                                            style={{
                                              width: 350,
                                              textAlign: "justify",
                                            }}>
                                            <p>
                                              <b>{e.name}</b>
                                            </p>
                                            <p>{e.description}</p>
                                            <div className="RecommendationsTable-popover-task">
                                              {e.tasks.map((t) => (
                                                <span
                                                  key={
                                                    t.id_recommendation_task
                                                  }>
                                                  <img src={checkIcon} />{" "}
                                                  {t.name}
                                                </span>
                                              ))}
                                            </div>
                                          </div>
                                        }>
                                        <TruncateText
                                          line={2}
                                          text={e.name}
                                          truncateText="…"
                                        />
                                      </Popover>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          )}
                        </div>
                        {!this.is_new && (
                          <>
                            <div
                              className="ModalACtionPlanCreate-component-view-content-columns-right-header"
                              style={{ marginTop: 20, marginBottom: 10 }}>
                              {
                                this.intl.modalActionPlanCreate.createModal
                                  .evidence.title
                              }
                            </div>
                            <div className="content-evidence">
                              <div>
                                {
                                  this.intl.modalActionPlanCreate.createModal
                                    .evidence.linkTitle
                                }{" "}
                                <span className="required">*</span>
                              </div>
                              <div>
                                <FormItem style={{ marginBottom: 11 }}>
                                  <Input
                                    maxLength={80}
                                    placeholder={
                                      this.intl.modalActionPlanCreate
                                        .createModal.evidence
                                        .linkTitlePlaceholder
                                    }
                                    value={this.state.linkTitle}
                                    onChange={(e) =>
                                      this.setState({
                                        linkTitle: e.target.value,
                                      })
                                    }
                                  />
                                </FormItem>
                              </div>
                              <div >
                                {
                                  this.intl.modalActionPlanCreate.createModal
                                    .evidence.linkDescription
                                }{" "}
                                <span className="required">*</span>
                              </div>
                              <div>
                                <FormItem >
                                  <Input
                                    maxLength={512}
                                    placeholder={
                                      this.intl.modalActionPlanCreate
                                        .createModal.evidence
                                        .linkDescriptionPlaceholder
                                    }
                                    value={this.state.linkDescription}
                                    onChange={(e) =>
                                      this.setState({
                                        linkDescription: e.target.value,
                                      })
                                    }
                                  />
                                </FormItem>
                              </div>
                              <Button
                                type="primary"
                                block
                                className="buttonAddEvidence"
                                disabled={!linkTitle || !linkDescription}
                                loading={this.state.addingEvidence}
                                onClick={this.addEvidence}>
                                {
                                      this.intl.actionPlanTaskForm
                                        .actions.add
                                    }
                              </Button>
                              {this.state.evidences.length > 0 && (
                                <div>
                                  <Divider style={{ borderColor: "#EDE9E9" ,marginTop:5,marginBottom:9}} />
                                  <div className="ModalACtionPlanCreate-component-view-content-columns-right-header">
                                    {
                                      this.intl.modalActionPlanCreate
                                        .createModal.evidence.addedLinks
                                    }
                                  </div>
                                  <div className="evidence-list">
                                    {this.state.evidences.map((ev) => {
                                      const clickable = ev.url.startsWith(
                                        "http"
                                      )
                                      if (!ev.isEditing) {
                                        return (

                                          <div
                                            id={`evidenceList-${ev.id}`}
                                            className="evidence-item"
                                            onClick={() =>
                                              clickable &&
                                              window.open(ev.url, "_blank")
                                            }
                                            style={{
                                              borderRadius: 6,
                                              marginBottom: 14,
                                              cursor: clickable
                                                ? "pointer"
                                                : "default",
                                              backgroundColor: clickable
                                                ? "#FAFAFA"
                                                : "white",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (clickable)
                                                e.currentTarget.style.background =
                                                  "#EBF5FF"
                                            }}
                                            onMouseLeave={(e) => {
                                              if (clickable)
                                                e.currentTarget.style.background =
                                                  "white"
                                            }}>
                                              <Row>
                                              <Col span={20}>
                                              <div className="row-between">
                                                <Space size={6}>
                                                  <Tooltip title={ev.title}>
                                                    <span>
                                                      <LinkOutlined
                                                        style={{
                                                          marginRight: 6, fontSize: "16px" 

                                                        }}
                                                      />
                                                      {ev.title.length > 28
                                                        ? ev.title.slice(
                                                            0,
                                                            28
                                                          ) + "..."
                                                        : ev.title}
                                                    </span>
                                                  </Tooltip>
                                                  <span className="span-small" style={{color: "#979797" }}>
                                                    {ev.date
                                                      ? moment(ev.date).format(
                                                          "DD/MM/YYYY"
                                                        )
                                                      : ""}
                                                  </span>
                                                </Space>
                                              </div>
                                              <Tooltip title={ev.url}>
                                              <div className="span-small" style={{ marginLeft: 22,color: "#979797" }}>
                                                {ev.url.length > 42
                                                  ? ev.url.slice(0, 42) + "..."
                                                  : ev.url}
                                              </div>
                                            </Tooltip>
                                              </Col>
                                              <Col span={4} style={{ display: "flex", alignItems: "center" }}>
                                              <div
                                                style={{
                                                  right: 10,
                                                  top: 8,
                                                }}>
                                                  <Space size={4} align="center">
                                                <Tooltip title={
                                      this.intl.actionPlanCard.actions.edit
                                    }>
                                                  <Button
                                                    size="small"
                                                    type="link"
                                                    icon={<EditFilled style={{ fontSize: "16px" }} />}
                                                    onClick={(e) => {
                                                      e.stopPropagation()
                                                      this.editEvidence(ev.id)
                                                    }}
                                                  />
                                                </Tooltip>
                                                <Tooltip title={
                                      this.intl.actionPlanTask.actions.delete
                                    }>
                                                  <Button
                                                    size="small"
                                                    type="link"
                                                    danger
                                                    icon={<DeleteOutlined  style={{ fontSize: "16px" }}/>}
                                                    onClick={(e) => {
                                                      e.stopPropagation()
                                                      this.removeEvidence(ev.id)
                                                    }}
                                                  />
                                                </Tooltip>
                                                </Space>
                                              </div>
                                              </Col>
                                            </Row>
                                           
                                          </div>
                                        )
                                      } else {
                                        return (
                                          <EditEvidenceForm
                                            id={`evidenceEdit-${ev.id}`}
                                            data={{ ev }}
                                            key={ev.id}
                                            intl={this.intl}
                                            onEvidenceChange={(
                                              updatedEvidence
                                            ) => {
                                              this.setState((prevState) => ({
                                                evidences: prevState.evidences.map(
                                                  (ev) =>
                                                    ev.id === updatedEvidence.id
                                                      ? updatedEvidence
                                                      : ev
                                                ),
                                              }))
                                            }}
                                          />
                                        )
                                      }
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                            <Onboarding section="pda-evidence-edit" />
                            <ModalDeleteSimple
                          visible={this.state.modalDeleteEvidence}
                          content={
                            <Fragment>
                              <p>
                                <b style={{ fontSize: "14" }}>
                                  {this.intl.modalActionPlanCreate.createModal.evidence.messageDeleteEvidence}
                                </b>
                              </p>
                              <p style={{ fontSize: "14" }}>
                                {this.intl.modalActionPlanCreate.createModal.evidence.messageDeleteEvidenceSecond}
                              </p>
                            </Fragment>
                          }
                          onOk={this.handleConfirmDeleteEvidence}
                          onCancel={this.handleCancelDeleteEvidence}
                        />
                          </>
                        )}
                       
                      </div>
                    </div>
                  </div>
                  <ButtonsFooter
                    style={{
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      zIndex: 9,
                    }}
                    buttons={[
                      {
                        content: this.intl.modalActionPlanCreate.createModal
                          .actions.cancel,
                        onClick: () => {
                          woopraTrack("Salir de creación de action plan")
                          this.setState({
                            modalClose: true,
                            loadingButton: false,
                          })
                        },
                        type: "",
                      },
                      {
                        disabled: !!(
                          selectedDimension.length === 0 ||
                          name.length === 0 ||
                          !selectedAmbassador ||
                          tasks.length === 0 ||
                          taskCreate ||
                          tasks.filter((e) => e.edit).length > 0 ||
                          this.state.newTasks.length > 0
                        ),
                        content: this.is_new
                          ? this.intl.modalActionPlanCreate.createModal.actions
                              .create
                          : this.intl.modalActionPlanCreate.createModal.actions
                              .save,
                        onClick: () => {
                          woopraTrack("Finalizar Crear Plan de acción")
                          validateFieldsAndScroll((err, values) => {
                            if (!err) {
                              this.saveActionPlan()
                            }
                          })
                        },
                        type: "primary",
                        loading: loadingSave,
                      },
                    ]}
                  />
                </Fragment>
              )}
            </div>
          )}
        </Fade>
        <ModalDeleteSimple
          visible={modalDeleteTaks}
          content={
            <Fragment>
              <p>{this.intl.modalActionPlanCreate.deleteModal.title}</p>
            </Fragment>
          }
          onOk={() => {
            const { tasks, currentTaskIndex } = this.state
            tasks.splice(currentTaskIndex, 1)
            this.setState({
              tasks,
              currentTaskIndex: null,
              modalDeleteTaks: false,
            })
          }}
          onCancel={() =>
            this.setState({
              modalDeleteTaks: false,
              currentTaskIndex: null,
            })
          }
        />

        <ModalCustom
          modalOpen={modalReplaceRecommendation}
          showFooter
          onOk={() => {
            this.selectRecommendation(temporalRecommendation)
            this.setState({ modalReplaceRecommendation: false })
          }}
          textButton={this.intl.modalActionPlanCreate.selectModal.select}
          onCancel={() => this.setState({ modalReplaceRecommendation: false })}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            {this.intl.modalActionPlanCreate.selectModal.title}
          </span>
          <p>{this.intl.modalActionPlanCreate.selectModal.text}</p>
        </ModalCustom>

        <ModalCustom
          action="salir de creación de action plan"
          modalOpen={modalClose}
          showFooter
          onOk={() => {
            this.setState(
              {
                viewModalAction: false,
                newTasks: [],
                tasks: [],
              },
              () => {
                this.cancelModal()
              }
            )
          }}
          textButton={this.intl.modalActionPlanCreate.exitModal.accept}
          onCancel={() => this.setState({ modalClose: false })}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            {this.intl.modalActionPlanCreate.exitModal.title}
          </span>
          <p>{sanitize(this.intl.modalActionPlanCreate.exitModal.text)}</p>
        </ModalCustom>
      </Fragment>
    )
  }
}

ModalActionPlanCreate.propTypes = {}
ModalActionPlanCreate.defaultProps = {
  canCreate: () => {},
  modalActionPlanEditId: null,
  modalActionPlanCreateIa: null,
  is_dashboard: false,
  finish: () => {},
  setMeasures: () => {},
  initialData: null,
}
export default Form.create({ name: "modal_create_plan_action" })(
  ModalActionPlanCreate
)
